import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-homebannermenu',
  templateUrl: './homebannermenu.component.html',
  styleUrls: ['./homebannermenu.component.scss']
})
export class HomebannermenuComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private modalService: NgbModal, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  
  public homebannerForm: FormGroup;
  public homebanners=[];
  submitted = false;
  message = null;
  class = null;
  action = null;

  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false,
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      name1: {
        title: 'Name'
      },
      url1: {
        title: 'Url'
      },
      name2: {
        title: 'Name'
      },
      url2: {
        title: 'Url'
      },
      name3: {
        title: 'Name'
      },
      url3: {
        title: 'Url'
      },
      name4: {
        title: 'Name'
      },
      url4: {
        title: 'Url'
      },
    },
  };

  ngOnInit() {
    this.homebannerForm = this.formBuilder.group({
      name1: ['', Validators.required],
      url1: ['', [Validators.required]],
      name2: ['', Validators.required],
      url2: ['', [Validators.required]],
      name3: ['', Validators.required],
      url3: ['', [Validators.required]],
      name4: ['', Validators.required],
      url4: ['', [Validators.required]],
      name5: ['', Validators.required],
      url5: ['', [Validators.required]],
      cardtitle1: ['', [Validators.required]],
      cardtitle2: ['', [Validators.required]],
      cardtitle3: ['', [Validators.required]],
      url6: ['', [Validators.required]],
      url7: ['', [Validators.required]],
      // url8: ['', [Validators.required]],
      content1: ['', [Validators.required]],
      content2: ['', [Validators.required]],
      content3: ['', [Validators.required]],
      desc1: ['', [Validators.required]],
      desc2: ['', [Validators.required]],
      desc3: ['', [Validators.required]],
      content4: ['', [Validators.required]],
      content5: ['', [Validators.required]],
      content6: ['', [Validators.required]],
      desc4: ['', [Validators.required]],
      desc5: ['', [Validators.required]],
      desc6: ['', [Validators.required]],
      aluheading: ['', [Validators.required]],
      aludesc: ['', [Validators.required]],
      alurecruiters: ['', [Validators.required]],
      aluplacements: ['', [Validators.required]],
      alupackage: ['', [Validators.required]],
      _id: [''],
    });

    this.http.get<any>(this.api_endpoint+'/homebannermenu/').subscribe(
        data => {
          this.homebanners = data.data;
          // console.log(this.homebanners);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    this.http.get<any>(this.api_endpoint+'/homebannermenufindone/').subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.homebannerForm.patchValue({
              name1: data.data.name1,
              url1: data.data.url1,
              name2: data.data.name2,
              url2: data.data.url2,
              name3: data.data.name3,
              url3: data.data.url3,
              name4: data.data.name4,
              url4: data.data.url4,
              name5: data.data.name5,
              url5: data.data.url5,
              cardtitle1: data.data.cardtitle1,
              cardtitle2: data.data.cardtitle2,
              cardtitle3: data.data.cardtitle3,
              url6: data.data.url6,
              url7: data.data.url7,
              // url8: data.data.url8,
              content1: data.data.content1,
              content2: data.data.content2,
              content3: data.data.content3,
              desc1: data.data.desc1,
              desc2: data.data.desc2,
              desc3: data.data.desc3,
              content4: data.data.content4,
              content5: data.data.content5,
              content6: data.data.content6,
              desc4: data.data.desc4,
              desc5: data.data.desc5,
              desc6: data.data.desc6,
              aluheading : data.data.aluheading,
              aludesc : data.data.aludesc,
              alurecruiters : data.data.alurecruiters,
              aluplacements : data.data.aluplacements,
              alupackage : data.data.alupackage,
              _id: data.data._id,
            })
          }else{
            this.action = 'Submit';
            this.homebannerForm.patchValue({
              name1: '',
              url1: '',
              name2: '',
              url2: '',
              name3: '',
              url3: '',
              name4: '',
              url4: '',
              name5: '',
              url5: '',
              cardtitle1: '',
              cardtitle2: '',
              cardtitle3: '',
              url6: '',
              url7: '',
              // url8: '',
              content1: '',
              content2: '',
              content3: '',
              desc1: '',
              desc2: '',
              desc3: '',
              content4: '',
              content5: '',
              content6: '',
              desc4: '',
              desc5: '',
              desc6: '',
              aluheading : '',
              aludesc : '',
              alurecruiters : '',
              aluplacements : '',
              alupackage : '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.homebannerForm.controls; }

  onFormSubmit(action){
    // alert(action);
    console.log(this.homebannerForm.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "name1" : this.homebannerForm.value.name1,
        "url1" : this.homebannerForm.value.url1,
        "name2" : this.homebannerForm.value.name2,
        "url2" : this.homebannerForm.value.url2,
        "name3" : this.homebannerForm.value.name3,
        "url3" : this.homebannerForm.value.url3,
        "name4" : this.homebannerForm.value.name4,
        "url4" : this.homebannerForm.value.url4,
        "name5" : this.homebannerForm.value.name5,
        "url5" : this.homebannerForm.value.url5,
        "cardtitle1" : this.homebannerForm.value.cardtitle1,
        "cardtitle2" : this.homebannerForm.value.cardtitle2,
        "cardtitle3" : this.homebannerForm.value.cardtitle3,
        "url6" : this.homebannerForm.value.url6,
        "url7" : this.homebannerForm.value.url7,
        // "url8" : this.homebannerForm.value.url8,
        "content1" : this.homebannerForm.value.content1,
        "content2" : this.homebannerForm.value.content2,
        "content3" : this.homebannerForm.value.content3,
        "desc1" : this.homebannerForm.value.desc1,
        "desc2" : this.homebannerForm.value.desc2,
        "desc3" : this.homebannerForm.value.desc3,
        "content4" : this.homebannerForm.value.content4,
        "content5" : this.homebannerForm.value.content5,
        "content6" : this.homebannerForm.value.content6,
        "desc4" : this.homebannerForm.value.desc4,
        "desc5" : this.homebannerForm.value.desc5,
        "desc6" : this.homebannerForm.value.desc6,
        "aluheading" : this.homebannerForm.value.aluheading,
        "aludesc" : this.homebannerForm.value.aludesc,
        "alurecruiters" : this.homebannerForm.value.alurecruiters,
        "aluplacements" : this.homebannerForm.value.aluplacements,
        "alupackage" : this.homebannerForm.value.alupackage,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.homebannerForm.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/homebannermenu', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "name1" : this.homebannerForm.value.name1,
        "url1" : this.homebannerForm.value.url1,
        "name2" : this.homebannerForm.value.name2,
        "url2" : this.homebannerForm.value.url2,
        "name3" : this.homebannerForm.value.name3,
        "url3" : this.homebannerForm.value.url3,
        "name4" : this.homebannerForm.value.name4,
        "url4" : this.homebannerForm.value.url4,
        "name5" : this.homebannerForm.value.name5,
        "url5" : this.homebannerForm.value.url5,
        "cardtitle1" : this.homebannerForm.value.cardtitle1,
        "cardtitle2" : this.homebannerForm.value.cardtitle2,
        "cardtitle3" : this.homebannerForm.value.cardtitle3,
        "url6" : this.homebannerForm.value.url6,
        "url7" : this.homebannerForm.value.url7,
        // "url8" : this.homebannerForm.value.url8,
        "content1" : this.homebannerForm.value.content1,
        "content2" : this.homebannerForm.value.content2,
        "content3" : this.homebannerForm.value.content3,
        "desc1" : this.homebannerForm.value.desc1,
        "desc2" : this.homebannerForm.value.desc2,
        "desc3" : this.homebannerForm.value.desc3,
        "content4" : this.homebannerForm.value.content4,
        "content5" : this.homebannerForm.value.content5,
        "content6" : this.homebannerForm.value.content6,
        "desc4" : this.homebannerForm.value.desc4,
        "desc5" : this.homebannerForm.value.desc5,
        "desc6" : this.homebannerForm.value.desc6,
        "aluheading" : this.homebannerForm.value.aluheading,
        "aludesc" : this.homebannerForm.value.aludesc,
        "alurecruiters" : this.homebannerForm.value.alurecruiters,
        "aluplacements" : this.homebannerForm.value.aluplacements,
        "alupackage" : this.homebannerForm.value.alupackage,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/homebannermenu', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
